// import when we move more to modules
export default window.Backbone.Model;
